import React from 'react'

export const IconCrown = React.forwardRef<SVGSVGElement>(
  (props: React.SVGProps<SVGSVGElement>, ref) => (
    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" {...props} ref={ref}>
      <path
        d="M13.7195 4.55383C13.4919 4.37111 13.1852 4.35521 12.9426 4.51358L10.0096 6.41691L7.58214 2.46061C7.55113 2.42397 7.51636 2.39134 7.47851 2.3633L8.15262 1.63086C8.28922 1.48251 8.28922 1.24203 8.15262 1.09368L7.24755 0.111261C7.11089 -0.0370871 6.88934 -0.0370871 6.75267 0.111261L5.84755 1.09368C5.71095 1.24203 5.71095 1.48251 5.84755 1.63086L6.52166 2.3633C6.48363 2.39134 6.44863 2.42397 6.41738 2.46061L3.98981 6.41691L1.06041 4.51054C0.5985 4.20938 0.00945167 4.56391 0.000106424 5.14871C-0.000965005 5.21532 0.00605882 5.28174 0.0209398 5.34636L1.42094 11.4248C1.49892 11.7629 1.77886 12 2.09987 12H11.8996C12.2211 12.0003 12.5015 11.7627 12.5793 11.424L13.9792 5.34558C14.0473 5.04901 13.9449 4.73707 13.7195 4.55383Z"
        fill="currentColor"
      />
    </svg>
  ),
)
